<template>
  <div id="app">
    <router-view/>
    <!-- 全局登录对话框 -->
    <login-dialog ref="loginDialog"></login-dialog>
    <!-- 联系我们悬浮按钮（门户首页不显示） -->
    <contact-us v-if="!isLandingPage"></contact-us>
  </div>
</template>

<script>
  import LoginDialog from '@/components/LoginDialog'
  import ContactUs from '@/components/ContactUs'
  
  export default {
    name: 'App',
    components: {
      LoginDialog,
      ContactUs
    },
    computed: {
      isLandingPage() {
        return this.$route.name === 'landing'
      }
    },
    mounted() {
      // 监听全局显示登录对话框事件
      this.$root.$on('show-login-dialog', () => {
        this.$nextTick(() => {
          if (this.$refs.loginDialog) {
            this.$refs.loginDialog.show()
          }
        })
      })
    },
    beforeDestroy() {
      // 移除事件监听
      this.$root.$off('show-login-dialog')
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue